// extracted by mini-css-extract-plugin
export default {"card":"assessment-progress_card__GCrYE","accordionHeader":"assessment-progress_accordionHeader__QbFN2"};